import script from "./PortalTarget.vue?vue&type=script&lang=js"
export * from "./PortalTarget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__